export default {
	STARTED: 'started',
	PREVENTING: 'preventing',
	CHANGING: 'changing',
}
